<template>
  <v-dialog
    v-model="showModal"
    persistent
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <v-card-title>
        <h2>Filter Invoices</h2>
      </v-card-title>
      <br>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <div>
            <v-row>
              <v-col cols="6">
                <v-dialog
                  ref="fromStartDialog"
                  v-model="fromStartCalendar"
                  :return-value.sync="formData.startDate"
                  width="290px"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="formData.startDate"
                      placeholder="Start Date"
                      outlined
                      filled
                      readonly
                      background-color="transparent"
                      hint="Please select a date to filter"
                      color="#37474f"
                      dense
                      light
                      prepend-inner-icon="mdi-calendar-month-outline"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-if="fromStartCalendar"
                    v-model="formData.startDate"
                    full-width
                    color="#37474F"
                    light
                    @input="$refs.fromStartDialog.save(formData.startDate)"
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="#37474F"
                      @click="fromStartCalendar = false"
                    >
                      Cancel
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="6">
                <v-dialog
                  ref="fromEndDialog"
                  v-model="fromEndCalendar"
                  :return-value.sync="formData.endDate"
                  width="290px"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="formData.endDate"
                      placeholder="End Date"
                      outlined
                      filled
                      readonly
                      background-color="transparent"
                      hint="Please select a date to filter"
                      color="#37474f"
                      dense
                      light
                      prepend-inner-icon="mdi-calendar-month-outline"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-if="fromEndCalendar"
                    v-model="formData.endDate"
                    full-width
                    color="#37474F"
                    light
                    :min="formData.startDate"
                    @input="$refs.fromEndDialog.save(formData.endDate)"
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="#37474F"
                      @click="fromEndCalendar = false"
                    >
                      Cancel
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>
            <v-select
              v-if="showStatus"
              v-model="formData.status"
              light
              color="#37474F"
              flat
              dense
              :items="status"
              item-text="name"
              item-value="id"
              label="Status"
              outlined
              background-color="transparent"
              class="small-select"
            />
            <v-select
              v-model="formData.jobId"
              light
              color="#37474F"
              flat
              dense
              :items="jobsList"
              item-text="name"
              item-value="external_id"
              label="Job"
              outlined
              background-color="transparent"
              class="small-select"
            />
          </div>
        </v-form>
        <div>
          <v-btn
            class="next-style"
            elevation="0"
            color="#64CA7F"
            @click="filter()"
          >
            Filter
          </v-btn>&nbsp;&nbsp;
          <v-btn
            class="cancel-style"
            elevation="0"
            color="#F5F5F5"
            @click="showModal = false"
          >
            Cancel
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'FilterInvoice',
  props: {
    showStatus: {
      type: Boolean,
      default: false,
    },
    filterType: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    showModal: true,
    valid: false,
    formData: {
      startDate: null,
      endDate: null,
      jobId: null,
      status: null,
    },
    status: [
      {
        name: 'Approved',
        id: 'approved',
      },
      {
        name: 'Pending',
        id: 'pending',
      },
      {
        name: 'Unpaid',
        id: 'unpaid',
      },
      {
        name: 'Rejected',
        id: 'rejected',
      },
    ],
    fromStartCalendar: false,
    fromEndCalendar: false,
  }),
  computed: {
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    jobsList () {
      return this.$store.getters['jobs/getAcceptedJobs'];
    },
    preInvoiceFilters () {
      return this.$store.getters['invoice/getInvoiceFilters'];
    },
    prePaidInvoiceFilters () {
      return this.$store.getters['invoice/getPaidInvoiceFilters'];
    },
    preDraftInvoiceFilters () {
      return this.$store.getters['invoice/getDraftInvoiceFilters'];
    },
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  async mounted () {
    await this.loadOnMount();
    await this.fetchJobs();
  },
  methods: {
    loadOnMount () {
      if (this.filterType === 'outstanding') {
      this.formData.startDate = this.preInvoiceFilters.startDate;
      this.formData.endDate = this.preInvoiceFilters.endDate;
      this.formData.jobId = this.preInvoiceFilters.jobId;
      this.formData.status = this.preInvoiceFilters.status;
      } else if (this.filterType === 'paid') {
      this.formData.startDate = this.prePaidInvoiceFilters.startDate;
      this.formData.endDate = this.prePaidInvoiceFilters.endDate;
      this.formData.jobId = this.prePaidInvoiceFilters.jobId;
      } else {
      this.formData.startDate = this.preDraftInvoiceFilters.startDate;
      this.formData.endDate = this.preDraftInvoiceFilters.endDate;
      this.formData.jobId = this.preDraftInvoiceFilters.jobId;
      }
    },
    async fetchJobs () {
      await this.$store
        .dispatch('jobs/fetchAcceptedJobs', {
          externalId: this.selectedOrganization.organization.external_id,
          params: {
            params: {
              status: 'accepted',
            },
          },
        });
    },
    async filter () {
      if (this.filterType === 'outstanding') {
      await this.$store.dispatch('invoice/saveInvoiceFilters', this.formData);
      this.$emit('success');
      this.showModal = false;
      } else if (this.filterType === 'paid') {
        await this.$store.dispatch('invoice/savePaidInvoiceFilters', this.formData);
        this.$emit('success');
        this.showModal = false;
      } else {
        await this.$store.dispatch('invoice/saveDraftInvoiceFilters', this.formData);
        this.$emit('success');
        this.showModal = false;
      }
    },
  },
};
</script>

<style scoped>
.next-style,
.cancel-style {
  height: 30px !important;
  font-size: 12px;
  width: 80px;
  font-weight: lighter !important;
  text-transform: none !important;
}

.theme--dark.v-list {
  background-color: white !important;
}

.theme--dark>>>.v-list-item {
  color: #37474f !important;
}
</style>
